import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation, useParams } from "react-router-dom";
import { FaLuggageCart } from "react-icons/fa";

const Purchases = ({ direction }) => {
  const location = useLocation();
  const { slug, lang } = useParams();
  const [_] = useTranslation("global");
  const [isSubNavVisible, setIsSubNavVisible] = useState(false);
  const role = localStorage.getItem("role");
  const employee_type = localStorage.getItem("employee_type");

  useEffect(() => {
    if (location.pathname.includes("/panel/purchases/")) {
      setIsSubNavVisible(true);
    } else {
      setIsSubNavVisible(false);
    }
  }, [location.pathname]);
  const handleClick = () => {
    setIsSubNavVisible(!isSubNavVisible);
  };
  
  return (
    <div className="links-container d-flex flex-column">
      <div className="d-flex flex-column">
        <div
          className={`feature_link ${
            lang === "en" ? "feature_link_en" : ""
          } d-flex flex-row-reverse align-items-center gap-2 py-3 ${
            isSubNavVisible ? "active-link" : ""
          }`}
          dir={direction}
          onClick={handleClick}
        >
          <FaLuggageCart className="icon" />

          <p>{_("panel.purchases")}</p>
        </div>
        <ul
          className={`${
            isSubNavVisible ? "d-flex" : "d-none"
          } sub-nav flex-column gap-2 px-5 pt-3`}
        >
          {role == "admin" ? (
            <>
              <li>
                <NavLink to={`/${slug}/${lang}/panel/purchases/suppliers`}>
                  <p className="d-inline ">{_("panel.suppliers")}</p>
                </NavLink>
              </li>
            </>
          ) : (
            ""
          )}

          {role == "admin" ? (
            <>
              <li>
                <NavLink
                  to={`/${slug}/${lang}/panel/purchases/variants-history`}
                >
                  <p className="d-inline ">{_("panel.variantsStockHistory")}</p>
                </NavLink>
              </li>
            </>
          ) : (
            ""
          )}
        </ul>
      </div>
    </div>
  );
};

export default Purchases;
